<template lang="pug">
  CoreBlock(:class="$style.comparisonTable" :block="{...block, innerHtml: getTableWithReplacedImage(block.innerHtml)}")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { replaceUrlS3Helper } from "~/scripts/useful-functions"

export default defineComponent({
  name: "ComparisonTable",
  props: {
    block: {
      required: true,
      type: Object as () => Block
    }
  },
  methods: {
    getTableWithReplacedImage(innerHtml: string): string {
      return replaceUrlS3Helper(
        innerHtml,
        this.$config.public.cdnUrl,
        this.$config.public.graphqlEndpoint
      )
    }
  }
})
</script>

<style lang="css" module>
.comparisonTable {
  @apply w-full text-center border-collapse;

  img {
    @apply max-h-ds-xl min-h-[auto];
  }

  :global {
    tr th,
    tr td {
      height: 64px;
      min-width: 72px;
      padding: 0 16px;
    }
    tr th {
      @apply font-normal;
      border-radius: 16px 16px 0 0;
    }
    tr td {
      border: 1px solid #c5c5c5;
    }
    tr:first-child th {
      border-top: 0;
    }
    tr:last-child td {
      border-bottom: 0;
    }
    tr td:first-child,
    tr th:first-child {
      @apply border-l-0 p-ds-sm;
    }
    tr td:last-child,
    table tr th:last-child {
      border-right: 0;
    }
    tr th:nth-child(2),
    tr td:nth-child(2) {
      background-color: rgba(177, 227, 255, 0.35);
    }
  }
}

@screen md {
  .comparisonTable {
    :global {
      img {
        width: 48px;
        margin: auto;
      }

      tr th,
      tr td {
        min-width: 96px;
      }
    }
  }
}

@screen lg {
  .comparisonTable {
    :global {
      img {
        width: 104px;
      }

      tr th,
      tr td {
        height: 104px;
        min-width: 184px;
      }

      tr th {
        @apply text-rebrandSm;
      }

      tr td {
        @apply text-rebrandMd;
      }

      tr td:first-child {
        @apply text-center;
      }
    }
  }
}

:global(article) .comparisonTable {
  @apply mt-ds-lg;
  :global(table) {
    @apply w-full;
    :global {
      tr th,
      tr td {
        @apply text-lg;
      }
      tr td:first-child,
      tr th:first-child {
        @apply w-auto;
      }
    }
  }
}
</style>
